import React, { Component } from 'react';

import { RelatedEntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import UsuarioGrupo from '../../../models/UsuarioGrupo';
import { Usuario } from 'hay-core-react';
import Grupo        from '../../../models/Grupo';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    usuario: {
        exibir:    'main.usuariogrupo.usuario',
        visivel:   true,
        tipo:      'relacao',
        camporelacao: 'nome',
        entidade:  'usuario.entidade',
        template:  'usuario.template',
        validacao: { obrigatorio: true }
    },
    grupo: {
        exibir:    'main.usuariogrupo.grupo',
        visivel:   true,
        tipo:      'relacao',
        entidade:  'grupo.entidade',
        template:  'grupo.template',
        camporelacao: 'nome',
        validacao: { obrigatorio: true },
        // Publicacao só existe em `state.model` pra quem acessou por uma publicação de acesso
        // geral (EntityGrid injeta o campo condicionalmente, ver mesclarCamposPadrao) - pra todo
        // mundo mais, o valor vem undefined e o filtro é ignorado (buildBlueprintQuery já trata
        // isso), já que o backend escopa Grupo pela publicacao da própria sessão de qualquer
        // forma. Sem esse filtro, o dropdown de Grupo mistura grupos de todos os tenants quando
        // quem está vinculando tem permiteacessogeral - achado em produção, especificações
        // 183/186.
        filtro: (contexto) => ({
            publicacao: { constraints: [{ value: contexto.state.model.publicacao?.value, matchMode: 'equals' }] },
        }),
    },
    token: {
        exibir:  'main.usuariogrupo.token',
        visivel: false,
        largura: '20rem',
    },
    validopor: {
        exibir:    'main.usuariogrupo.validopor',
        visivel:   false,
        tipo:      'numeric',
        keyfilter: 'num',
    },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    usuario: { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
    grupo:   { entidade: Grupo,   template: (rowData) => rowData.grupo?.nome   || rowData.grupo?.id   || '' },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class UsuarioGrupoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.usuario} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.grupo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.token} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.validopor} contexto={contexto} />
                </div>
            </>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class UsuarioGrupoTemplate extends Component {

    render() {
        return (
            <RelatedEntityGrid
                entidade={UsuarioGrupo}
                model={model}
                identidade="main.usuariogrupo"
                icone="pi-link"
                permissoes={this.props.permissoes}
                storageKey="dt-usuariogrupos"
                processos={[]}
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                formulario={(m, ctx) => <UsuarioGrupoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default UsuarioGrupoTemplate;
